<script setup lang='ts'>
const props = withDefaults(defineProps<{
  tips?: {
    type: 'pre' | 'next'
    title: string
    id: string
  }
}>(), {})

const { isDesktop } = useDevice()
</script>

<template>
  <div
    v-if="tips && !isDesktop"
    class="fixed top-0 left-0 bottom-0 right-0 text-gray-700 pt-30vh z-10 selected-none pointer-events-none bg-white opacity-0"
  >
    <div v-if="tips.type === 'pre'" class="flex items-center relative pl-4">
      <div mr-2>
        <i class="i-material-symbols:arrow-circle-left-rounded text-8" />
      </div>
      <div class="flex-grow">
        <p>上一篇</p>
        <p class="w-60% mt-1">
          {{ tips?.title }}
        </p>
      </div>
    </div>
    <div v-else class="flex items-center flex-row-reverse relative pr-4">
      <div ml-2>
        <i class="i-material-symbols:arrow-circle-right-rounded text-8" />
      </div>
      <div class="flex flex-col flex-grow">
        <p class="text-right">
          下一篇
        </p>
        <p class="w-60% mt-1 self-end text-right">
          {{ tips?.title }}
        </p>
      </div>
    </div>
  </div>
</template>

<style lang='scss' scoped>

</style>
